import script from "./AdminDeleteAccountDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminDeleteAccountDialog.vue?vue&type=script&setup=true&lang=js"

import "./AdminDeleteAccountDialog.vue?vue&type=style&index=0&id=73bbab58&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73bbab58"]])

export default __exports__